import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  inject,
  input,
  Input,
  signal,
} from '@angular/core';
import { BrandService } from './brand.service';

@Component({
  selector: 'mulo-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'mulo-brand' },
  imports: [],
})
export class BrandComponent {
  service = inject(BrandService);
  private elementRef = inject(ElementRef);

  readonly label = input<string>('Logo image');
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set logoLight(url: string) {
    this.service.setLogoLight(url);
  }

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set logoDark(url: string) {
    this.service.setLogoDark(url);
  }

  readonly width = input<string | number>(undefined);
  readonly imageWidth = signal<number>(null);
  readonly calcWidth = computed(() => {
    const imageWidth = this.imageWidth();
    if (imageWidth === 0) {
      return this.maxWidth();
    } else {
      if (imageWidth > this.maxWidth()) {
        return this.maxWidth();
      } else {
        return this.width() ?? imageWidth;
      }
    }
  });

  readonly minWidth = signal(100);
  readonly maxWidth = signal(200);
  readonly opacity = signal(0);

  readonly widthless = computed(
    () => this.imageWidth() === null || this.imageWidth() === 0,
  );

  readonly widthString = computed(
    () => this.calcWidth() + (typeof this.calcWidth() === 'number' ? 'px' : ''),
  );

  readonly brandLogo = computed(() => {
    const logoUrls = this.service.logoUrls();
    const logoStyle = getComputedStyle(this.elementRef.nativeElement)
      .getPropertyValue('--contrast-type')
      .trim();
    return logoStyle === 'light' ? logoUrls.light : logoUrls.dark;
  });

  onImageLoaded(ev) {
    const ratio = ev.target.naturalHeight / ev.target.height;
    this.minWidth.set(0);
    this.imageWidth.set(ev.target.naturalWidth / ratio || ev.target.width);
    this.opacity.set(1);
  }
}
